// Angular
import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, Inject, ViewChild, ViewRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
// RxJS
import { Observable, BehaviorSubject, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
// NGRX
// Service
import { SubheaderService } from 'app/core/_base/layout';
import { LayoutUtilsService, MessageType } from 'app/core/_base/crud';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { ListDialogService } from '../Services/list-dialog.service';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import {DungChungService} from '../../../dung-chung/__services/dung-chung.service'
//Models
export class manyFile{
	name: string
	image: string
	errMess: string
	idAttach : number
	clear(){
		this.name = "";
		this.image = "";
		this.errMess = "";
		this.idAttach = null;
	}
}


@Component({
	selector: 'kt-chon-nhieu-file',
	templateUrl: './chon-nhieu-file.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChonNhieuFileComponent implements OnInit, OnDestroy {
	// Public properties

	@ViewChild('fileUpload', { static: true }) fileUpload;
	CONFIG: CommonConFig;
	LoaiTaiSanForm: FormGroup;
	hasFormErrors: boolean = false;

	loadingSubject = new BehaviorSubject<boolean>(true);
	loading$: Observable<boolean>;
	idAttach: number = null;
	viewLoading: boolean = false;
	isChange: boolean = false;
	_soLanImport: number = 0;
	_dataImport: any[] = [];
	selectedFiles: FileList;
	newFileList: File[] = [];
	progressInfos = [];
	message = '';
	imageSrc: string;
  	fileInfos: Observable<any>;
	manyFile : manyFile[] = []
	private componentSubscriptions: Subscription;
	
	constructor(
		public dialogRef: MatDialogRef<ChonNhieuFileComponent>,
		private LoaiTaiSanFB: FormBuilder,
		public dialog: MatDialog,
		private layoutUtilsService: LayoutUtilsService,
		private DungChungService: DungChungService,
		private changeDetectorRefs: ChangeDetectorRef,
		private service: ListDialogService,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private changeDetect: ChangeDetectorRef,
		) {}
	/**
	 * On init
	 */
	ngOnInit() {
		
		this.viewLoading = false;
		this.CONFIG = new CommonConFig();
		this.createForm();
			if(this.data.data != null){
			
				this.newFileList = [...this.data.data];
				this.newFileList.forEach(element => {
					var res = element.name.match(/.jpg$|.jpeg$|.png$|.JPG$|.JPEG$|.PNG$/g);
					const ManyFile = new manyFile();
					ManyFile.clear();
					ManyFile.name =element.name;
					
					if(res)	{	
						this.imageSrc = res.toString();									
						const reader = new FileReader();
						reader.readAsDataURL(element);
						reader.onload = (event:any) => {
							if((event.target.result).split('/')[0] != "data:image")
							{
								const image = "data:image/"
								ManyFile.image = "data:image/"+this.imageSrc.split(".")[1]+";base64," + (event.target.result).split(',')[1];
							}
							else{
								ManyFile.image = event.target.result;
							}
							
							//this.imageSrc.push(event.target.result); 
							this.changeDetectView();	
						}
						
					}
					this.manyFile.push(ManyFile);
						
				});
			}	
			else if(this.data.id != null && this.data.id != ""){
				this.idAttach = Number(this.data.id);
				this.DungChungService.listFileData(this.idAttach).subscribe(res => {
					if (res.data != null) {
						res.data.forEach(element => {
							this.DungChungService.getFile(element.Id).subscribe(res => {
								if (res != null) {				
									const file = new File([res],element.TenFileGoc);
									this.newFileList.push(file);

									const ManyFile = new manyFile();
									ManyFile.clear();
									ManyFile.name = element.TenFileGoc;
									ManyFile.idAttach = element.Id;
									var result = element.TenFileGoc.match(/.jpg$|.jpeg$|.png$|.JPG$|.JPEG$|.PNG$/g);

									if(result)	{	
										this.imageSrc = result.toString();									
										const reader = new FileReader();
										reader.readAsDataURL(file);
										reader.onload = (event:any) => {
											if((event.target.result).split('/')[0] != "data:image")
											{
												const image = "data:image/"
												ManyFile.image = "data:image/"+this.imageSrc.split(".")[1]+";base64," + (event.target.result).split(',')[1];
											}
											else{
												ManyFile.image = event.target.result;
											}
											
											//this.imageSrc.push(event.target.result); 
											this.changeDetectView();	
										}}



									this.manyFile.push(ManyFile);
									this.LoaiTaiSanForm.controls['FileDuLieu'].setValue("Số file đã chọn: "+this.manyFile.length+" file");
									this.changeDetectView();	

								}
							});
						});
						
					}
				});
			
			}
			if(this.data.canDelete == true){
				this.isChange = true;
			}
			this.LoaiTaiSanForm.controls['SelectFile'].disable();
			this.LoaiTaiSanForm.controls['FileDuLieu'].setValue("Số file đã chọn: "+this.manyFile.length+" file");
			this.changeDetectView();	
	}
	/**
	 * On destroy
	 */
	ngOnDestroy() {
		
	}
	/**
	 * Create form
	 */
	createForm() {
		this.LoaiTaiSanForm = this.LoaiTaiSanFB.group({
			FileDuLieu: [''],
			SelectFile: [''],
		});
	}

	/**
	 * Check control is invalid
	 * @param controlName: string
	 */
	isControlInvalid(controlName: string): boolean {
		const control = this.LoaiTaiSanForm.controls[controlName];
		const result = control.invalid && control.touched;
		return result;
	}

	onAlertClose($event) {
		this.hasFormErrors = false;
	}
	numberOnly(event): boolean {
		const charCode = (event.which) ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
		return true;
	}
	closeDialog() {
		var check = true;
		this.manyFile.forEach(element => {
			if(element.errMess != ''){
				this.layoutUtilsService.showActionNotification("Lỗi dữ liệu, vui lòng kiểm tra lại!", MessageType.Error, 3000, true, false);
				check = false;
			}
		});
		if(check == true){
			
			this.dialogRef.close({data:this.newFileList});
			if(this.newFileList != null){
				this.layoutUtilsService.showInfo("Thêm file thành công");
			}
			
		}
		
	}
	closedDialog() {
		this.dialogRef.close();
	}

	selectFile() {	
		if(this.isChange == true){
			let el: HTMLElement = this.fileUpload.nativeElement as HTMLElement;
			el.click();
		}
		else{
			this.layoutUtilsService.showErorr("Chỉ được phép xem file");
		}
	}
	FileSelected(evt: any) {
		
		
		if (evt.target.files && evt.target.files.length) {//Nếu có file
			if(evt.target.files.length > 20)	{
				this.layoutUtilsService.showErorr("Vượt quá số file quy định");
			}else{
				this.selectedFiles = evt.target.files;
				if(this.newFileList != null){
					Array.from(this.selectedFiles).forEach(element => {
						if(!this.checkDataIsValid(element)){
							this.newFileList.push(element);
						}
						
					});
				}else{
					this.newFileList = Array.from(this.selectedFiles);

				}
			
				for (let i = 0; i < this.selectedFiles.length; i++) { 
					if(this.manyFile.length > 20)	{
						this.layoutUtilsService.showErorr("Vượt quá số file quy định");
						break;
					}
					var res = evt.target.files[i].name.match(/.jpg$|.jpeg$|.png$|.JPG$|.JPEG$|.PNG$/g);
					var errorFile = evt.target.files[i].name.match(/.exe$|.js$|.cs$/g);
					const ManyFile = new manyFile();
					ManyFile.clear();
					ManyFile.name = evt.target.files[i].name;
					if(errorFile){
						ManyFile.errMess = "File không hợp lệ";
					}
					if(evt.target.files[i].size > 10000000)	{
						ManyFile.errMess = "File vượt quá dung lượng";
					}
					if(evt.target.files[i].name.length > 10)	{
						ManyFile.errMess = "Tên file quá dài";
					}
					if(this.checkDataIsValid(evt.target.files[i]))	{
						continue;
					}
					if(res)	{										
						const reader = new FileReader();
						 reader.readAsDataURL(evt.target.files[i]);
						 reader.onload = (event:any) => {
							ManyFile.image = event.target.result;
							//this.imageSrc.push(event.target.result); 
							this.changeDetectView();	
						}
						
					}
					this.manyFile.push(ManyFile);
						
				}
				this.LoaiTaiSanForm.controls['FileDuLieu'].setValue("Số file đã chọn: "+this.manyFile.length+" file");
			}
			
	
		}
		else {//Không có file
			this.LoaiTaiSanForm.controls['FileDuLieu'].patchValue('');
		}
	}
	downloadFile(item: any){
		let linkdownload = 	this.DungChungService.downloadFile(item.idAttach);
		console.log(linkdownload)
		window.open(linkdownload);
		  
		
	}
	getFile(item:any){
		this.DungChungService.getFile(item.idAttach).subscribe(res => {
			if (res != null) {				
				console.log(res)
			}
		});;
	}
	checkDataIsValid(item: File): boolean {
		if(this.manyFile.length == 0){
			return false;
		}
		for(var i = 0; i < this.manyFile.length; i++){
			if(this.manyFile[i].name == item.name){
				return true;
			}
		}
		return false;
	}
	clearItem(item:manyFile){
	
		for(let i = 0 ; i < this.manyFile.length;i++){
			if(this.manyFile[i].name == item.name){
				this.manyFile.splice(i, 1);
				i--;
			}
		}
		this.manyFile = [...this.manyFile];
	
		
		for(let i = 0 ; i < this.newFileList.length;i++){
			if(this.newFileList[i].name == item.name){
				this.newFileList.splice(i, 1);
				i--;
			}
		}
		this.newFileList = [...this.newFileList];
		this.LoaiTaiSanForm.controls['FileDuLieu'].setValue("Số file đã chọn: "+this.manyFile.length+" file");
		this.layoutUtilsService.showInfo("File đã được xoá");
		this.changeDetectView();
	}
	
	
	selectFiles(event) {
		this.progressInfos = [];
		this.selectedFiles = event.target.files;
		this.changeDetectView();
		
	}
	Importfile() {
		
		let el: any = this.fileUpload.nativeElement;
		var useBase64: boolean = true;
		for (var idx = 0; idx < el.files.length; idx++) {
			if (useBase64) {
				var fileName = el.files[idx].name;
				let reader = new FileReader();
				reader.readAsDataURL(el.files[idx]);
				reader.onload = function () {
					let base64Str = reader.result as String;
					var metaIdx = base64Str.indexOf(';base64,');
					base64Str = base64Str.substr(metaIdx + 8); // Cắt meta data khỏi chuỗi base64
					var data = {
						fileName: fileName,
						base64: base64Str,
					};
					
				};
			}
			else {
				let inputs = new FormData();
				inputs.append('file', el.files[idx]);
			}
		}
	}
	
	changeDetectView(){
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}

}
